import { fromPairs, toPairs } from 'ramda'

import { DesktopReportsInOrgMutateParams } from 'app/common/types/reports/desktop'

import type { Request } from '../../../index'

type ParamsDto = {
  schools_ids: Array<number>
  settings: {
    desktop_reports: Record<
      string,
      {
        school_enabled: boolean
        restrict_print?: boolean
      }
    >
  }
}

export const convertParams = ({
  orgIds,
  reportsSettings,
}: DesktopReportsInOrgMutateParams): [ParamsDto, null] => {
  const pairs = toPairs(reportsSettings) || []
  return [
    {
      schools_ids: orgIds.map((id) => parseInt(id, 10)),
      settings: {
        desktop_reports: fromPairs(
          pairs.map(([id, { schoolEnabled, restrictPrint }]) => {
            const dto: { school_enabled: boolean; restrict_print?: boolean } = {
              school_enabled: schoolEnabled,
            }

            if (restrictPrint !== undefined) {
              dto.restrict_print = restrictPrint
            }

            return [id, dto]
          }),
        ),
      },
    },
    null,
  ]
}

type ResultDto = 'success'

export const convertResult = (data: ResultDto): unknown => {
  return data === 'success'
}

export const POST_SCHOOL_REPORTS_LIST: Request<DesktopReportsInOrgMutateParams, boolean, void> = [
  'food/schools/reports_list',
  'post',
  ['data', 'result'],
]
